/**
 * <s-countdown launch="ISO-8601 datetime" [reload-on-launch]>
 * Counts down to the launch instant and swaps caller-owned regions:
 *   [data-launch-state="before"] shows until launch, [data-launch-state="after"] from launch on.
 * Digits render into [data-countdown-unit="days|hours|minutes|seconds"].
 * With reload-on-launch, the page reloads once at launch so server-gated forms refresh.
 */
class SCountdown extends HTMLElement {
  connectedCallback() {
    this.launchAt = Date.parse(this.getAttribute('launch') || '');
    if (Number.isNaN(this.launchAt)) return;
    this.units = {};
    for (const el of this.querySelectorAll('[data-countdown-unit]')) {
      this.units[el.dataset.countdownUnit] = el;
    }
    this.wasLaunched = Date.now() >= this.launchAt;
    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  tick() {
    const remaining = Math.max(0, this.launchAt - Date.now());
    const launched = remaining === 0;

    for (const el of this.querySelectorAll('[data-launch-state]')) {
      el.hidden = (el.dataset.launchState === 'after') !== launched;
    }
    this.toggleAttribute('data-launched', launched);

    const seconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(seconds / 86400),
      hours: Math.floor((seconds % 86400) / 3600),
      minutes: Math.floor((seconds % 3600) / 60),
      seconds: seconds % 60,
    };
    for (const [unit, el] of Object.entries(this.units)) {
      const text = String(values[unit] ?? 0).padStart(2, '0');
      if (el.textContent !== text) el.textContent = text;
    }

    if (launched) {
      window.clearInterval(this.timer);
      if (!this.wasLaunched && this.hasAttribute('reload-on-launch')) {
        window.location.reload();
      }
    }
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
